module.exports = __webpack_public_path__ + "img/centros-logisticos-0ccb5d9f.jpg";